module.exports = __webpack_public_path__ + "img/pet-silhouette.afec2619.webp";